<template>
    <div id="add-registered-at">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn :color="primaryColor" dark small v-bind="attrs" v-on="on"
                    @click.stop="openAddRegisteredAtDialog()">
                    <v-icon>mdi-book-plus</v-icon>
                </v-btn>
            </template>
            <span>Add Registered At</span>
        </v-tooltip>
        <v-dialog v-model="addRegisteredAtDialog" max-width="576" persistent>
            <v-card>
                <v-card-title>
                    Add Registered At
                </v-card-title>
                <v-card-text>
                    <v-form ref="addRegisteredAtForm" v-model="valid" lazy-validation>
                        <v-text-field v-model="currentRegisteredAt.location" clearable label="Location"
                            :rules="locationRules" required>
                        </v-text-field>
                        <v-select v-model="currentRegisteredAt.default"
                            hint="Set as default choice for the Online Residence Application form" :items="defaultItems"
                            label="Default" persistent-hint :rules="defaultRules" required>
                        </v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="addBtn" class="white--text" :color="successColor" :disabled="!valid"
                        @click="openAddRegisteredAtConfirmationDialog()">
                        Add
                    </v-btn>
                    <v-btn ref="closeBtn" :color="warningColor" @click="closeAddRegisteredAtDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addRegisteredAtConfirmationDialog" max-width="540">
            <v-card ref="addRegisteredAtConfirmationCard">
                <v-card-title>Confirmation</v-card-title>
                <v-card-text>
                    Are you sure you would like to add <b>{{ currentRegisteredAt.location }}</b> as a Registered At?
                    Please
                    click
                    confirm to proceed.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="confirmBtn" :color="dangerColor" text @click="addRegisteredAt()">
                        Confirm
                    </v-btn>
                    <v-btn :color="warningColor" text @click="closeAddRegisteredAtConfirmationDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'registered-at-add',
    data() {
        return {
            addRegisteredAtDialog: false,
            addRegisteredAtConfirmationDialog: false,
            currentRegisteredAt: {
                default: '0',
                location: ''
            },
            defaultItems: [{
                    text: 'Yes',
                    value: '1'
                },
                {
                    text: 'No',
                    value: '0'
                }
            ],
            defaultRules: [
                v => !(v === "") || 'Default is required',
            ],
            locationRules: [
                v => !!v || 'Location is required',
                v => (v && v.length >= 2) || 'Location must be more than 2 characters',
            ],
            valid: true
        }
    },
    methods: {
        addRegisteredAt() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?updateEntity`;

            // Parse array into string
            formData.append('data', JSON.stringify(this.currentRegisteredAt));
            formData.append('mode', 'updateEntity');
            formData.append('type', 'RegisteredAt');

            // Loading icon
            this.$refs.confirmBtn.loading = true;

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `${that.currentRegisteredAt.location} has been successfully added as a Registered At.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `${that.currentRegisteredAt.location} could not be added as a Registered At. Please contact your system administrator.`, true);
                    }

                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.closeAddRegisteredAtConfirmationDialog();
                    that.closeAddRegisteredAtDialog();
                })
                .catch(function () {
                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        closeAddRegisteredAtConfirmationDialog() {
            this.addRegisteredAtConfirmationDialog = false;
        },
        closeAddRegisteredAtDialog() {
            this.addRegisteredAtDialog = false;
        },
        openAddRegisteredAtConfirmationDialog() {
            // Validate form before confirmation
            if (this.$refs.addRegisteredAtForm.validate()) {
                this.addRegisteredAtConfirmationDialog = true;
            }
        },
        openAddRegisteredAtDialog() {
            // Reset form
            this.resetForm();
            this.addRegisteredAtDialog = true;
        },
        resetForm() {
            // Reset form validation
            this.resetFormValidation();

            // Reset current registered at
            this.currentRegisteredAt.default = '0';
            this.currentRegisteredAt.location = '';
        },
        resetFormValidation() {
            if (this.$refs.addRegisteredAtForm) {
                this.$refs.addRegisteredAtForm.resetValidation();
            }
        },
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>